export default {
    LoginEmptyError: 'login error empty',
    LoginSessionError: 'login error session',
    WrongCurrentPassword: 'wrong current password',
    SameEmail: 'same email',
}
